import { NavLink, useLocation, useParams } from 'react-router-dom';
import { Box, NavItem } from '@optiaxiom/react';

import CanUser from '@frontend/components/CanUser';
import { FeatureFlag } from '@frontend/contexts';
import { OperationsName } from '@frontend/types';

import * as styles from './NavigationItem.css';

type NavigationItemProps = {
  path: string;
  icon: JSX.Element;
  label: string;
  permissions: OperationsName[];
  featureFlag?: string;
  showIndicator?: boolean;
};

/* TODO: Add doc string */
export const NavigationItem = ({
  path,
  icon,
  label,
  permissions,
  featureFlag,
}: NavigationItemProps) => {
  const location = useLocation();
  const { instanceId } = useParams();
  const selectedRoute = location.pathname.split('/')[3] || 'chat';

  const navItem = (
    <NavLink
      to={`/instances/${instanceId}/${path}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <Box className={styles.navItemContainer}>
        <NavItem active={selectedRoute === path} icon={icon}>
          {label}
        </NavItem>
      </Box>
    </NavLink>
  );

  const withPermission = <CanUser operations={permissions}>{navItem}</CanUser>;

  if (featureFlag) {
    return <FeatureFlag featureKey={featureFlag}>{withPermission}</FeatureFlag>;
  }

  return withPermission;
};
